import React from "react";
import { Box } from "@mui/material";
import { pageShellSx } from "../../utils/responsive";

/**
 * Wraps route content so every page inherits overflow-safe full-width layout.
 */
const PageShell = ({ children, sx = {} }) => (
  <Box component="main" sx={{ ...pageShellSx, ...sx }}>
    {children}
  </Box>
);

export default PageShell;
